import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Image, Slideshow } from 'components';
import { media } from "utils/media";

// CMS Content
import pressData from "cms/content/about-press.yml";

const SectionPress = ({ className }) => {
  const [open, toggleOpen] = useState(false);
  const [active, handleChange] = useState(0);
  const visiblePress = open ? pressData.press : pressData.press.slice(0, 3);

  return (
    <>
    <h2 className='section-title mb-50'>{pressData.title}</h2>
    <div className={className}>
      <div className='section-press'>
        <Slideshow slidesPerPage={1} onChange={handleChange} value={active}>
          {visiblePress.map(({ title, image, alt, style, link }, idx) =>
            <div key={idx} className='press-wrapper'>
              <div className='press-logo'>
                <Image url={media(image)} alt={alt} className={style} />
              </div>
              <h3>{title}</h3>
              <a href={link} target="_blank" rel="noopener noreferrer" path={link} class="button outline mt-a">Read</a>
            </div>
          )}
        </Slideshow>
        <div className='press-nav'>
          <Button label='previous' onClick={() => handleChange(active-1)} className='button-press-prev' aria-label='Previous article' />
          <Button label='next' onClick={() => handleChange(active+1)} className='button-press-next' aria-label='Next article' />
        </div>
      </div>

      {!open &&
        <div className='flex-center mt-50'>
          <Button label='See more press' level='outline' onClick={toggleOpen} />
        </div>
      }
    </div>
    </>
  );
};

SectionPress.propTypes = {
  className: PropTypes.string.isRequired,
};

SectionPress.defaultProps = {
  className: '',
};

export default SectionPress;
